export const deviceTypes = {
    1: {
        name: "Картходлер",
        value: "CHARTHOLDER",
        img: "cardholder",
    },
    2: {
        name: "Выключатель",
        value: "SWITCH",
        img: "switch",
    },
    3: {
        name: "Датчик движения",
        value: "MOTION_SENSOR",
        img: "motion_sensor",
    },
    4: {
        name: "Датчик открытия",
        value: "OPENING_SENSOR",
        img: "opening_sensor",
    },
    5: {
        name: "Вентиляция",
        value: "VENTILATION",
        img: "ventilation",
    },
    6: {
        name: "Датчик протечки",
        value: "LEAK_SENSOR",
        img: "leak_sensor",
    },
    7: {
        name: "Датчик температуры воздуха",
        value: "AIR_TEMPERATURE_SENSOR",
        img: "thermometer",
    },
    8: {
        name: "Шторы с приводом",
        value: "CURTAINS",
        img: "curtains",
    },
    9: {
        name: "Освещение",
        value: "LIGHTING",
        img: "lighting",
    },
    10: {
        name: "Розетка",
        value: "SOCKET",
        img: "socket",
    },
    11: {
        name: "Холодильник",
        value: "FRIDGE",
        img: "fridge",
    },
    12: {
        name: "Отопление",
        value: "HEATING",
        img: "heating",
    },
    13: {
        name: "Полы с подогревом",
        value: "UNDERFLOOR_HEATING",
        img: "warm_floor",
    },
    14: {
        name: "Клапан перекрытия воды",
        value: "WATER_SHUT_OFF",
        img: "water_shut_off",
    },
    15: {
        name: "Диммируемое освещение",
        value: "DIMMABLE_LIGHTING",
        img: "lighting",
    },
    16: {
        name: "Телевизор",
        value: "TELEVISION",
        img: "tv",
    },
    17: {
        name: "Датчик освещенности",
        value: "LIGHT_SENSOR",
        img: "light_sensor",
    },
    18: {
        name: "Датчик влажности",
        value: "AIR_HUMIDITY_SENSOR",
        img: "humidity_sensor",
    },
}
export default deviceTypes;



// class ChannelType:
// DRY_CONTACT = 1
// RELAY = 2
// AIR_TEMPERATURE_SENSOR = 3
// IR_RECEIVER_AND_EMITTER = 4
// CURTAINS = 5
// DIMMER = 6
// HEATING = 7
// UNDERFLOOR_HEATING = 8
//
// CHOICES = (
//     (DRY_CONTACT, 'Сухой контакт'),
//         (RELAY, 'Реле'),
//         (AIR_TEMPERATURE_SENSOR, 'Датчик температуры и/или влажности'),
//         (IR_RECEIVER_AND_EMITTER, 'ИК-приёмник/излучатель'),
//         (CURTAINS, 'Шторы'),
//         (DIMMER, 'Внешний диммер'),
//         (HEATING, 'Отопление'),
//         (UNDERFLOOR_HEATING, 'Пол с подогревом'),
// )
//
// RIGHTS = {
//     DRY_CONTACT: ('ro',),
//     AIR_TEMPERATURE_SENSOR: ('ro',),
//     RELAY: ('ro', 'wo',),
//     DIMMER: ('ro', 'wo',),
//     IR_RECEIVER_AND_EMITTER: ('ro', 'wo',),
//     CURTAINS: ('ro', 'wo',),
//     HEATING: ('ro', 'wo',),
//     UNDERFLOOR_HEATING: ('ro', 'wo',),
// }
//
// CHANNELS_FORMAT = {
//     DRY_CONTACT: {
//         'value': bool
//     },
//     RELAY: {
//         'value': bool
//     },
//     AIR_TEMPERATURE_SENSOR: {
//         'temperature': float,
//         'humidity': int,
//     },
//     IR_RECEIVER_AND_EMITTER: {
//         'command': str,
//     },
//     CURTAINS: {
//         'value': int,
//     },
//     DIMMER: {
//         'value': int,
//     },
//     HEATING: {
//         'value': float,
//     },
//     UNDERFLOOR_HEATING: {
//         'value': float,
//     },
// }